export default __webpack_public_path__ + "/dist/images/2482910.png";